import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetBlocksForCollectionQuery } from '../../../services/entities/impl/blfApi/endpoints/collections';
import { Collection } from '../../../services/entities/impl/blfApi/schemas/collection';

export const useGetCollectionBlocks = (id: Collection['id'] | undefined) => {
  return useGetBlocksForCollectionQuery(id ?? skipToken);
};
